import { render, staticRenderFns } from "./AllStudents.vue?vue&type=template&id=0a412d35&scoped=true&"
import script from "./AllStudents.vue?vue&type=script&lang=js&"
export * from "./AllStudents.vue?vue&type=script&lang=js&"
import style0 from "./AllStudents.vue?vue&type=style&index=0&id=0a412d35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a412d35",
  null
  
)

export default component.exports